// extracted by mini-css-extract-plugin
export default {"moduleHead":"index_moduleHead_P4hnE","moduleHeadLine":"index_moduleHeadLine_sHt7L","moduleHeadTitle":"index_moduleHeadTitle_1dNPg","moduleHeadMore":"index_moduleHeadMore_7J7N9"};